import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ChatbotWidget } from "../components/ChatbotWidget";
import { customerApi } from "../lib/customerApi";
import { formatINR } from "../lib/api";

const STATUS_TONES = {
    pending: "bg-beige text-inkDark",
    paid: "bg-green-50 text-green-700",
    shipped: "bg-skyblue/40 text-inkDark",
    delivered: "bg-skyblueDeep/15 text-skyblueDeep",
    cancelled: "bg-red-50 text-red-700",
    refunded: "bg-inkDark/5 text-inkMuted",
    failed: "bg-red-50 text-red-700",
};

export default function Orders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        customerApi.get("/orders").then(({ data }) => setOrders(data || [])).catch(() => setOrders([])).finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-ivory" data-testid="orders-page">
            <Header />
            <main className="max-w-[1100px] mx-auto px-6 lg:px-12 py-12">
                <span className="label-eyebrow">Your purchases</span>
                <h1 className="mt-3 font-display text-4xl sm:text-5xl text-inkDark tracking-tight">Orders</h1>

                {loading ? (
                    <div className="mt-10 text-inkMuted">Loading…</div>
                ) : orders.length === 0 ? (
                    <div className="mt-10 bg-beige rounded-2xl p-12 text-center" data-testid="orders-empty">
                        <p className="text-inkMuted">You haven&rsquo;t placed any orders yet.</p>
                        <Link to="/category/sarees" className="btn-pill mt-6 inline-flex">Start shopping</Link>
                    </div>
                ) : (
                    <div className="mt-10 space-y-4" data-testid="orders-list">
                        {orders.map((o) => (
                            <Link
                                key={o.id}
                                to={`/orders/${o.id}`}
                                className="block bg-ivory border border-inkDark/5 rounded-2xl p-5 hover:shadow-soft transition-shadow"
                                data-testid={`order-row-${o.id}`}
                            >
                                <div className="flex flex-wrap items-start justify-between gap-3">
                                    <div>
                                        <div className="text-xs text-inkMuted">Order #{o.id.slice(0, 8)}</div>
                                        <div className="mt-1 font-display text-xl text-inkDark">{o.items.length} {o.items.length === 1 ? "item" : "items"}</div>
                                        <div className="mt-1 text-sm text-inkMuted">{new Date(o.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</div>
                                    </div>
                                    <div className="text-right">
                                        <div className="font-medium text-inkDark">{formatINR(o.grandTotal)}</div>
                                        <span className={`mt-2 inline-block text-[10px] tracking-[0.18em] uppercase px-2.5 py-1 rounded-full ${STATUS_TONES[o.fulfillmentStatus] || STATUS_TONES.pending}`}>
                                            {o.fulfillmentStatus}
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-4 flex items-center gap-2 overflow-x-auto no-scrollbar">
                                    {o.items.slice(0, 5).map((it, idx) => (
                                        <img key={idx} src={it.image} alt="" className="w-12 h-16 rounded-md object-cover shrink-0" />
                                    ))}
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </main>
            <Footer />
            <ChatbotWidget />
        </div>
    );
}
